import type { HTMLAttributes } from 'react'
import { cn } from '@/shared/lib'

export type ChipTone = 'neutral' | 'accent' | 'success' | 'warning' | 'info'
export type ChipVariant = 'outline' | 'soft'

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: ChipTone
  variant?: ChipVariant
}

const byTone: Record<ChipTone, string> = {
  neutral: 'border-border-default text-text-secondary',
  accent: 'border-border-accent text-accent',
  success: 'border-border-default text-success',
  warning: 'border-border-default text-warning',
  info: 'border-border-default text-info',
}

// outline — статусы (pill + mono-caps); soft — теги/метки: заливка без рамки,
// sans, обычный регистр. Разные роли читаются как разные элементы.
const byVariant: Record<ChipVariant, string> = {
  outline: 'rounded-pill border font-mono text-xs uppercase tracking-wide',
  soft: 'rounded-control border border-transparent bg-bg-raised font-sans text-xs',
}

export function Chip({
  tone = 'neutral',
  variant = 'outline',
  className,
  children,
  ...rest
}: ChipProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1',
        byVariant[variant],
        variant === 'outline' ? byTone[tone] : 'text-text-secondary',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  )
}
